import { render } from "./AyudaFacturacion.vue?vue&type=template&id=7ea80abe&scoped=true"
import script from "./AyudaFacturacion.vue?vue&type=script&lang=js"
export * from "./AyudaFacturacion.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=7ea80abe&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea80abe"]])

export default __exports__